export const CURRENCY_SYMBOL = "IQD ";
